import { render, staticRenderFns } from "./bonus-rule.vue?vue&type=template&id=0f75a405&scoped=true&lang=pug&"
import script from "./bonus-rule.vue?vue&type=script&lang=js&"
export * from "./bonus-rule.vue?vue&type=script&lang=js&"
import style0 from "./bonus-rule.vue?vue&type=style&index=0&id=0f75a405&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75a405",
  null
  
)

export default component.exports